import * as React from "react";
const SvgCoordinates = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("circle", { cx: 12, cy: 12, r: 5, fill: "currentColor" }), /* @__PURE__ */ React.createElement("circle", { cx: 12, cy: 12, r: 9, stroke: "currentColor", strokeWidth: 2 }));
export default SvgCoordinates;
